import { render, staticRenderFns } from "./Ideas.vue?vue&type=template&id=baa28ede&scoped=true&"
import script from "./Ideas.vue?vue&type=script&lang=js&"
export * from "./Ideas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa28ede",
  null
  
)

export default component.exports